import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { getAllMessages,getMessage,getMessageLogs, getPriorities } from "./utils";


// Create the context
const MessagesContext = createContext();

// Create a provider component
export const MessagesProvider = ({ children }) => {
  const [reload, setReload] = useState(true);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState();
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedMessageLog, setSelectedMessageLog] = useState(null);
  const [selectedMessageLogs, setSelectedMessageLogs] = useState(null);
  const [filters, setFilters] = useState({
    activeOnly: false,
    includeIncidentMessages: true,
  });

  const [filterValues, setFilterValues] = useState({
    activeOnly:filters.activeOnly,
    includeIncidentMessages:filters.includeIncidentMessages,
  });

  useEffect(() => {
    console.log("selectedMessage", JSON.stringify(selectedMessage));
    if(selectedMessage!==null && selectedMessage.id !==null)
    // getMessage(selectedMessage.id,setMessage);
    setMessage(messages.filter(eachMessage=>
        eachMessage.id===selectedMessage.id
    )[0])
    
  }, [selectedMessage]);

  useEffect(() => {
//     getStates((data) => setFilterValues((prev) => ({ ...prev, states: data })));
//     getAgencies((data) =>
//       setFilterValues((prev) => ({ ...prev, agencies: data }))
//     );
    getPriorities((data) =>
      setFilterValues((prev) => ({ ...prev, priorities: data }))
    );
//     getRoadways((data) =>
//       setFilterValues((prev) => ({ ...prev, roadways: data }))
//     );
//     getType((data) =>
//       setFilterValues((prev) => ({ ...prev, type: data }))
//     );
  }, []);

  const loadMessages = useCallback(() => {
    getAllMessages(
      filters.activeOnly,
      filters.includeIncidentMessages,
      setMessages
    );
  }, [filters]);

  useEffect(() => {
    loadMessages();
    setReload(false);
  }, [loadMessages, reload]);

  useEffect(() => {
    if (null === selectedMessageLog) {
        setSelectedMessageLogs(null);
    } else {
      getMessageLogs(
        selectedMessageLog.id,
        setSelectedMessageLogs
      );
    }
  }, [selectedMessageLog]);

  return (
    <MessagesContext.Provider
      value={{
        message,
        messages,
        filters,
        selectedMessage,
        selectedMessageLog,
        filterValues,
        selectedMessageLogs,
        setSelectedMessageLog,
        setSelectedMessage,
        setFilters,
        setMessages,
        setMessage,
        setReload,
      }}
    >
      {children}
    </MessagesContext.Provider>
  );
};

// Custom hook to use the AnnouncementsContext
export const useMessages = () => {
  const context = useContext(MessagesContext);
  if (!context) {
    throw new Error(
      "useMessages must be used within an MessagesProvider"
    );
  }
  return context;
};
